<template>
  <div>
    <div class="content-box">
      <div class="os-tabs-w">
        <div class="os-tabs-controls os-tabs-complex text-right">
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <span aria-expanded="true" class="nav-link active"
                ><span class="tab-label">Saldo disponible:</span
                ><span v-if="current && current.inicial" class="tab-value">{{
                  current.inicial
                }}</span></span
              >
            </li>
            <li class="nav-item">
              <span aria-expanded="true" class="nav-link active"
                ><span class="tab-label">Fecha creación:</span
                ><span
                  v-if="current && current.fecha_creacion"
                  class="tab-value"
                  >{{ current.fecha_creacion }}</span
                ></span
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="os-tabs-w"></div>
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <router-link
                class="btn btn-sm btn-outline-info"
                :to="{ name: 'inventario-liquidacion-producto' }"
              >
                <i class="fas fa-angle-double-left"></i>
                Atras
              </router-link>
              <h5 class="form-header">
                <h5>Liquidación de producto</h5>
                &nbsp;
                <!-- <div class="st-meta float-right">
                  <div class="element-actions">
                    <button
                      type="button"
                      :disabled="current.estado == 'A'"
                      class="btn btn-outline-dark"
                      @click="imprimir"
                    >
                      <i class="fa fa-print"></i>
                      Imprimir
                    </button>
                    &nbsp;
                    <div class="btn-group">
                      <button
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="btn btn-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        type="button"
                      >
                        <i class="fa fa-cogs"></i>
                        Acciones
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <button
                          class="dropdown-item"
                          :disabled="!(current.estado == 'A')"
                          href="#"
                          type="button"
                        >
                          <i class="fa fa-lock"></i>
                          Cerrar Operación
                        </button>
                        <button
                          class="dropdown-item"
                          :disabled="!(current.estado != '9')"
                          href="#"
                        >
                          <i class="fa fa-archive"></i>
                          Anular Operación
                        </button>
                        <button
                          class="dropdown-item"
                          :disabled="
                            current.estado == '9' || current.estado == 'A'
                          "
                          href="#"
                        >
                          <i class="fas fa-power-off"></i>
                          Dar de Baja Orden Compra
                        </button>
                        <div class="dropdown-divider"></div>
                      </div>
                    </div>
                  </div>
                </div> -->
              </h5>
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger': current.errors && current.errors.tienda,
                      }"
                      >Tienda</label
                    >
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      required
                      v-model="current.tienda"
                      :disabled="current.estado == 'B'"
                    >
                      <option
                        v-for="(tienda, key) in tiendas"
                        :value="tienda.codigo"
                        :key="key"
                      >
                        {{ tienda.nombre }}
                      </option>
                    </select>
                    <small
                      v-if="current.errors && current.errors.tienda"
                      class="form-text text-danger"
                      >{{ current.errors.tienda }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-4">
                  <ProductoSelectComponentV2
                    :current="current"
                    :disabled="current.estado == 'B'"
                  />
                </div>
                <div class="col-sm-4">
                  <label>Usuario</label>
                  <input
                    :disabled="true"
                    type="text"
                    class="form-control"
                    v-model="current.usuario.username"
                  />
                </div>
                <div class="col-sm-3">
                  <label>Fecha inicio</label>
                  <input
                    :disabled="current.estado == 'B'"
                    type="date"
                    class="form-control"
                    v-model="current.fecha_inicio"
                  />
                </div>
                <div class="col-sm-3">
                  <label>Fecha fin</label>
                  <input
                    :disabled="current.estado == 'B'"
                    type="date"
                    class="form-control"
                    v-model="current.fecha_fin"
                  />
                </div>
                <div class="col-sm-3">
                  <label>Tipo liquidación</label>
                  <select
                    :disabled="current.estado == 'B'"
                    class="form-control"
                    v-model="current.liq_tipo"
                  >
                    <option
                      v-for="(detalle, key) in tipos_liq"
                      :value="detalle.id"
                      :key="key"
                    >
                      {{ detalle.descripcion }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-3">
                  <label>Saldo inicial</label>
                  <input
                    :disabled="current.estado == 'B'"
                    type="text"
                    class="form-control"
                    v-model="current.inicial"
                  />
                </div>
              </div>
              <div></div>
              <br />
              <h6>Detalle de kardex de liquidación</h6>
              <div class="invoice-table" v-if="current.id != null">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th style="width: 300px !important">Producto</th>
                      <th>Fecha creación</th>
                      <th>Cantidad</th>
                      <th>Observación</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(
                        detalle, indexDetalle
                      ) in current.liquidacionproductokardex_set"
                      :key="indexDetalle"
                    >
                      <td>
                        <div>{{ detalle.producto.sku }}</div>
                        <small class="value">{{
                          detalle.producto.nombre
                        }}</small>
                      </td>
                      <td>
                        {{
                          detalle.fecha_creacion
                            | moment("DD/MM/YYYY hh:mm:s a")
                        }}
                      </td>
                      <td>{{ detalle.cantidad }}</td>
                      <td>{{ detalle.observacion }}</td>
                    </tr>
                  </tbody>
                </table>

                <!-------------------- END - Basic Table -------------------->
              </div>
              <div class="form-buttons-w">
                <button
                  class="btn btn-md btn-success"
                  v-if="current.estado == 'A'"
                  type="button"
                  @click="guardar()"
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    TiendaSelectComponent,
    ProductoSelectComponentV2,
    UsuariosSelectComponent,
  },
  data() {
    return {
      current: {
        estado: "A",
        tienda: "",
        fecha: "",
        errors: [],
        usuario: "",
        fecha_inicio: "",
        fecha_fin: "",
        tipos_liq: "",
        producto: "",
      },
      detalle: {},
      tipos_liq: [],
      tiendas: [],
      currentDetalle: {},
      tiendas: "",
    };
  },
  computed: {},
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
    self.refreshTipoLiq();
    self.refreshTienda();
  },
  methods: {
    refreshTienda() {
      DynamicService.fetch("cat", "tiendas").then((response) => {
        this.tiendas = response.data.results;
      });
    },
    refreshTipoLiq() {
      DynamicService.fetch("cat", "tipo-liquidacion-pedido").then(
        (response) => {
          this.tipos_liq = response.data.results;
        }
      );
    },
    guardar() {
      this.detalle = this.current;
      if (this.current.producto) {
        this.detalle.producto = this.current.producto.sku;
      }
      this.detalle.fecha_inicio = this.dateSaveFormatter(
        this.detalle.fecha_inicio
      );
      this.detalle.fecha_fin = this.dateSaveFormatter(this.detalle.fecha_fin);
      console.log(this.detalle);
      DynamicService.save("inv", "liquidacion_producto", this.detalle)
        .then((response) => {
          Notifications.alert.success(
            "Agregar nueva liquidación de productos",
            "Agregado existosamente"
          );
          this.$router.push({
            name: "inventario-liquidacion-producto-editar",
            params: { id: response.data.id },
          });
          this.refreshCurrent();
        })
        .catch((errors) => {
          this.current.errors = errors.response.data;
        });
    },
    customFormatterInverted(date) {
      if (date == null) {
        return "";
      }
      var d = date.split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d).format("YYYY-MM-DD");
    },
    dateSaveFormatter(date) {
      if (date == null) {
        return "";
      }
      return moment(date).format("DD/MM/YYYY");
    },
    imprimir() {
      let self = this;
      OrdenCompraService.pdf(self.current.id)
        .then((response) => {
          window.open(response.data.output);
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById(
        "inv",
        "liquidacion_producto",
        this.$route.params.id
      ).then((response) => {
        self.current = response.data;
        if (self.current.tienda) {
          self.current.estado = "B";
        }
        self.current.fecha_inicio = this.customFormatterInverted(
          self.current.fecha_inicio
        );
        self.current.fecha_fin = this.customFormatterInverted(
          self.current.fecha_fin
        );
        self.current.fecha_creacion = moment(
          self.current.fecha_creacion
        ).format("YYYY-MM-DD");
      });
    },
  },
};
</script>
